<form>
  <h1 mat-dialog-title>{{ (service.isUpdateInstrument? 'Markets.General.addInstrument.headerEdit': 'Markets.General.addInstrument.headerNew') | translate }}</h1>
  <div class="container">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.lblCode' | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'Markets.General.lblCode' | translate}}" [(ngModel)]="instrument.code" [ngModelOptions]="{standalone: true}" required maxlength="50"/>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.lblDescription' | translate}}</mat-label>
            <input type="text" matInput placeholder="{{'Markets.General.lblDescription' | translate}}" [(ngModel)]="instrument.description" [ngModelOptions]="{standalone: true}" required/>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.addInstrument.lblTerm' | translate}}</mat-label>
            <input type="number" matInput placeholder="{{'Markets.General.addInstrument.lblTerm' | translate}}" [(ngModel)]="instrument.term" [ngModelOptions]="{standalone: true}" required/>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.thCalType' | translate}}</mat-label>
            <mat-select [(ngModel)]="instrument.calculationType.id" [ngModelOptions]="{standalone: true}" required>
              @for (calType of calculationTypes; track calType) {
                <mat-option [value]="calType.id">{{calType.value}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="row">
            <mat-form-field class="col-6" style="padding-left: 30px;">
              <mat-label>{{'Markets.General.addInstrument.lblConDecPlaces' | translate}}</mat-label>
              <mat-select #selector2 [(ngModel)]="conDecPlacesItem" [ngModelOptions]="{standalone: true}" required>
                <mat-option value="0">Default</mat-option>
                <mat-option value="1" (click)="selector2.open()"><input type="number" min="0" matInput [(ngModel)]="instrument.contributionDecimalPlaces" [ngModelOptions]="{standalone: true}" required/>@if (instrument.contributionDecimalPlaces >= 0) {
                  <span>{{instrument.contributionDecimalPlaces}}</span>
                }</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-6" style="padding-right: 30px;">
              <mat-label>{{'Markets.General.addInstrument.lblCalDecPlaces' | translate}}</mat-label>
              <mat-select #selector1 [(ngModel)]="calDecPlacesItem" [ngModelOptions]="{standalone: true}" required>
                <mat-option value="0">Default</mat-option>
                <mat-option value="1" (click)="selector1.open()"><input type="number" min="0" matInput [(ngModel)]="instrument.calculationDecimalPlaces" [ngModelOptions]="{standalone: true}" required/>@if (instrument.calculationDecimalPlaces >= 0) {
                  <span>{{instrument.calculationDecimalPlaces}}</span>
                }</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.thSpread' | translate}}</mat-label>
            <input type="number" step="0.001" min="0" matInput placeholder="{{'Markets.General.thSpread' | translate}}" [(ngModel)]="instrument.spread" [ngModelOptions]="{standalone: true}" required/>
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-12">
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.addInstrument.lblRefixTol' | translate}}</mat-label>
            <input type="number" min="0" step="0.001"  matInput [(ngModel)]="instrument.refixTolerance" [ngModelOptions]="{standalone: true}" required/>

          </mat-form-field>
          <div class="row">
            <mat-form-field class="col-6" style="padding-left: 30px;">
              <mat-label>{{'Markets.General.addInstrument.lblSpikeTol' | translate}}</mat-label>
              <input type="number" min="0" step="0.001"  matInput  [(ngModel)]="instrument.spikeTolerance" [ngModelOptions]="{standalone: true}" required/>
            </mat-form-field>
            <mat-form-field class="col-6" style="padding-right: 30px;">
              <mat-label>{{'Markets.General.addInstrument.lblD1SpikeTol' | translate}}</mat-label>
              <input type="number" min="0" step="0.001"  matInput  [(ngModel)]="instrument.d1SpikeTolerance" [ngModelOptions]="{standalone: true}" required/>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-6" style="padding-left: 30px;">
              <mat-label>{{'Markets.General.addInstrument.lblDynamicSpikeTol' | translate}}</mat-label>
              <input type="number" min="0" step="0.001"  matInput  [(ngModel)]="instrument.dynamicSpikeTolerance" [ngModelOptions]="{standalone: true}" required/>
            </mat-form-field>
            <mat-form-field class="col-6" style="padding-right: 30px;">
              <mat-label>{{'Markets.General.addInstrument.lblDynamicSpikeTolBuffer' | translate}}</mat-label>
              <input type="number" min="0" step="0.001"  matInput  [(ngModel)]="instrument.dynamicSpikeToleranceBuffer" [ngModelOptions]="{standalone: true}" required/>
            </mat-form-field>
          </div>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.addInstrument.lblStaticMovTol' | translate}}</mat-label>
            <input type="number" min="0" step="0.001"  matInput [(ngModel)]="instrument.staticMovementTolerance" [ngModelOptions]="{standalone: true}" required/>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.addInstrument.lblRelativeMovTol' | translate}}</mat-label>
            <input type="number" min="0" step="0.001"  matInput [(ngModel)]="instrument.relativeMovementTolerance" [ngModelOptions]="{standalone: true}" required/>

          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label>{{'Markets.General.addInstrument.lblConDevTol' | translate}}</mat-label>
            <input type="number" min="0" step="0.001"  matInput [(ngModel)]="instrument.contributionDeviationTolerance" [ngModelOptions]="{standalone: true}" required/>

          </mat-form-field>
        </div>
      </div>
      @if (isTransactional === true) {
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <mat-form-field class="col-12">
              <mat-label>{{'Markets.General.addInstrument.lblFuturesType' | translate}}</mat-label>
              <mat-select [(ngModel)]="instrument.listFuturesID" [ngModelOptions]="{standalone: true}" required>
                @for (furType of futuresTypes; track furType) {
                  <mat-option [value]="furType.id">{{furType.value}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-12">
              <mat-label>{{'Markets.General.addInstrument.lblForwardRates' | translate}}</mat-label>
              <mat-select multiple [(ngModel)]="instrument.forwardLookingRates" [ngModelOptions]="{standalone: true}">
                @for (forType of forwardLookingRates; track forType) {
                  <mat-option [value]="forType.id">{{forType.value}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-6 col-md-12">
            <mat-form-field class="col-12">
              <mat-label>{{'Markets.General.addInstrument.lblMinVol' | translate}}</mat-label>
              <mat-select #selector3 [(ngModel)]="minVolItem" [ngModelOptions]="{standalone: true}" required>
                <mat-option value="0">Default</mat-option>
                <mat-option value="1" (click)="selector3.open()"><input type="number" step="1" min="0" matInput [(ngModel)]="instrument.minimumVolume" [ngModelOptions]="{standalone: true}" required/>@if (instrument.minimumVolume >= 0) {
                  <span>{{instrument.minimumVolume}}</span>
                }</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="row">
              <mat-form-field class="col-6" style="padding-left: 30px;">
                <mat-label>{{'Markets.General.addInstrument.lblBucketLeft' | translate}}</mat-label>
                <input type="number" min="0" matInput [(ngModel)]="instrument.bucketLeft" [ngModelOptions]="{standalone: true}" required/>
              </mat-form-field>
              <mat-form-field class="col-6" style="padding-right: 30px;">
                <mat-label>{{'Markets.General.addInstrument.lblBucketRight' | translate}}</mat-label>
                <input type="number" min="0" matInput [(ngModel)]="instrument.bucketRight" [ngModelOptions]="{standalone: true}" required/>
              </mat-form-field>
            </div>
          </div>
        </div>
      }
    </div>
    <div mat-dialog-actions>
      @if (service.currentUser.userRole !== operatorRoleName) {
        <button mat-raised-button color="primary" (click)="OnSaveInstrument()">{{'btnOk' | translate}}</button>
        }&nbsp;
        <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
      </div>
    </div>
  </form>
